<app-chart-wrapper [title]="'Disbursed Loans'" i18n-title="@@disbursed_loans" [showExpandIcons]="false">
    <app-chart-filter filter [form]="disbursedLoanCountForm" [formControls]="disbursedLoanCountFormControls" (filter)="filterDisbursedLoansCount($event)"></app-chart-filter>
    <app-doughnut-chart chart></app-doughnut-chart>
</app-chart-wrapper>
